import { useSellerAuth } from "@/context/SellerAuthContext";
import { fileUrl } from "@/lib/api";
import { Store } from "lucide-react";

function Row({ k, v }) {
  if (!v) return null;
  return <div className="flex gap-3 py-1.5 text-sm"><span className="w-36 shrink-0 text-ink-muted">{k}</span><span className="text-ink">{v}</span></div>;
}

export default function SellerProfile() {
  const { seller } = useSellerAuth();
  if (!seller) return null;
  return (
    <div className="space-y-6" data-testid="seller-profile">
      <h1 className="font-heading text-2xl font-bold text-ink sm:text-3xl">Profile</h1>
      <div className="flex items-center gap-4 rounded-2xl border border-border/60 bg-white p-6 shadow-ambient">
        {seller.logo_id ? <img src={fileUrl(seller.logo_id)} alt="" className="h-16 w-16 rounded-2xl object-cover" /> : <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand/15 text-brand"><Store className="h-8 w-8" /></span>}
        <div>
          <p className="font-heading text-xl font-bold text-ink">{seller.shop_name}</p>
          <p className="text-sm text-ink-soft">{seller.business_type}</p>
        </div>
      </div>
      <div className="rounded-2xl border border-border/60 bg-white p-6 shadow-ambient">
        <h2 className="font-heading text-lg font-bold text-ink">Details</h2>
        <div className="mt-2 divide-y divide-border/50">
          <Row k="Owner" v={seller.owner_name} />
          <Row k="Mobile" v={seller.mobile} />
          <Row k="WhatsApp" v={seller.whatsapp_number} />
          <Row k="Email" v={seller.email} />
          <Row k="Address" v={[seller.address, seller.area, seller.city, seller.district, seller.state, seller.pincode].filter(Boolean).join(", ")} />
          <Row k="GSTIN" v={seller.gstin} />
          <Row k="FSSAI" v={seller.fssai} />
          <Row k="Fulfillment" v={`${seller.seller_delivery ? "Seller Delivery" : ""}${seller.seller_delivery && seller.customer_pickup ? " · " : ""}${seller.customer_pickup ? "Customer Pickup" : ""}`} />
        </div>
        <p className="mt-4 text-xs text-ink-muted">To update these details, please contact NICEE support.</p>
      </div>
    </div>
  );
}
